import { createContext } from 'react';
import { IAccordionContext } from './accordion.props';

export const AccordionTabContext = createContext<IAccordionContext>({
  data: [],
  ui: 'form',
  activeTabIndexList: [],
  toggleTab: () => {}
});
